import { render, staticRenderFns } from "./BadgePlusIcon.vue?vue&type=template&id=62f41440"
import script from "./BadgePlusIcon.vue?vue&type=script&lang=js"
export * from "./BadgePlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports